import { ConnectedRouter } from 'connected-react-router';
import { StrictMode } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ModalProvider } from 'react-simple-hook-modal';

import { gtmId, isStandaloneMode } from './config';
import initialize, { setUpInitFn } from './initialize';

import App from './ui/components/App';
import './ui/styles/index.scss';
import ErrorBoundary from './ui/components/shared/ErrorBoundary';
import GoogleTagManager from './ui/components/shared/GoogleTagManager';
import { InterfaceProvider } from './ui/context/InterfaceContext';
import { KeycloakProvider } from './ui/context/KeycloakProvider';

export const { store, history } = initialize();

setUpInitFn();

render(
    <StrictMode>
        <Provider store={store}>
            <KeycloakProvider>
                <InterfaceProvider>
                    <ConnectedRouter history={history}>
                        <ErrorBoundary>
                            <ModalProvider>
                                {isStandaloneMode && gtmId && <GoogleTagManager gtmId={gtmId} key="gaTag" />}
                                <App />
                            </ModalProvider>
                        </ErrorBoundary>
                    </ConnectedRouter>
                </InterfaceProvider>
            </KeycloakProvider>
        </Provider>
    </StrictMode>,
    document.getElementById('root')
);
